<template>
  <v-list-group
    v-model="active"
    :value="active_option === name ? true : false"
    class="navigation_item"
    :class="{'navigation_item--active': active_option === name}"
    :style="styleObject"
  >

    <v-list-tile slot="activator"
      class="principal_option"
      :class="active_option === name ? 'principal_option--active':''"
    >
    <!--{{selected_item}} -->
      <v-list-tile-action>
        <dashBoard v-if="name == 'dashboard'"
          :colorx="active ? color_rgba : color"
        > </dashBoard>
        <offer v-if="name == 'offer'"
          :colorx="active ? color_rgba : color"
        > </offer>
        <reward v-if="name == 'reward'"
          :colorx="active ? color_rgba : color"
        > </reward>
        <access v-if="name === 'access' || name === 'booking_office_section' || name === 'access_counter' || name === 'CounterPrinter_section'"
          :colorx="active ? color_rgba : color"
        > </access>
        <user v-if="name === 'users'"
          :colorx="active ? color_rgba : color"
        > </user>
        <location v-if="name === 'location'"
          :colorx="active ? color_rgba : color"
        > </location>
        <news v-if="name === 'news'"
          :colorx="active ? color_rgba : color"
        > </news>
        <clientinformation v-if="name === 'clientinformation'"
        :colorx="active ? color_rgba : color"
        > </clientinformation>
        <insiderequest v-if="name === 'form'"
        :colorx="active ? color_rgba : color"
        > </insiderequest>
        <message-icon v-if="name === 'notifications'"
        :colorx="active ? color_rgba : color"
        > </message-icon>
        <!-- <classNav v-if="name === 'classnav'"
        :colorx="active ? color_rgba : color"
        > </classNav> -->
        <!-- <events v-if="name === 'events'"
          :colorx="active ? color_rgba : color"
        > </events> -->
        <!-- <internalclientconnection v-if="name === 'internalclientconnection'"
          :colorx="active ? color_rgba : color"
        > </internalclientconnection> -->
        <!-- <insiderequest v-if="name === 'insiderequest'"
          :colorx="active ? color_rgba : color"
        > </insiderequest>
        <insiderequest v-if="name === 'form'"
          :colorx="active ? color_rgba : color"
        > </insiderequest>
        > </insiderequest> -->

      </v-list-tile-action>
      <v-list-tile-title style="margin-left: -5px">{{ title }}</v-list-tile-title>
    </v-list-tile>
    <template
      v-if="item.section === name"
      v-for="(item, i) in items"
    >
      <v-list-tile
        style="padding-left: 20px;"
        @click="changeRoute(item, link);"
        v-for="(link, index) in item.links" v-if="link.visible" >

        <v-icon
          v-if="selected_subitem === item.id+link.text"
          :style="{'color': color}"
          class="navigation__text--option_selected_icon"
        >
          radio_button_checked
        </v-icon>

        <v-icon v-else :style="{'color': '#5A6B8E'}">radio_button_unchecked</v-icon>

        <v-list-tile-content>
          <v-list-tile-title
            :title="link.text"
            :class="selected_subitem === item.id+link.text?'navigation__text--option_selected':'navigation__text--option'"
            :style="{'color': color}"
          >
            {{ link.text }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
  </v-list-group>

</template>
<script>
export default {
  props: {
    selected_item: String,
    selected_subitem: String,
    items: Array,
    name: String,
    title: String,
    color: String,
    open: Boolean,
  },
  data(){
    return {
      collapse: '',
      color_rgba: 'rgba(255, 255, 255, 0.598)',
      active: false,
    }
  },
  created(){
    this.active_option = this.active;
  },
  methods: {
    changeRoute(item, link){
      this.selected_subitem = item.id+link.text;
      this.$emit('update:selected_item', this.name)
      this.$emit('update:selected_subitem', item.id+link.text)
      if(link.current_section != null &&
          link.current_section != undefined &&
          link.current_section != ''){
            this.updateDashboardActive(link.current_section)
      }
      if(this.selected_subitem=='14Inicio'){
        this.$router.push({name: 'location_access', params: {id: localStorage.getItem('location_id'), filter:false, date: new Date().toISOString().substr(0, 10), date2: new Date().toISOString().substr(0, 10), namex: localStorage.getItem('location_name')}})
      }else if(this.selected_subitem=="16Resumen locación"){
        this.$router.push({name: 'location_access', params: {id: localStorage.getItem('location_id'), filter:false,date: new Date().toISOString().substr(0, 10),date2:new Date().toISOString().substr(0, 10),namex:localStorage.getItem('location_name')}})
      }else if(this.selected_subitem=="16Generar Reserva"){
        this.$router.push({name: 'booking_index', params: {id: localStorage.getItem('location_id'), location_name: localStorage.getItem('location_name')}})
      }else if(this.selected_subitem=="19Imprimir Ticket"){
        this.$router.push({name: 'counter_printer'})
      }else{
        this.$router.push({name: item.principal_route!='' ? item.principal_route +'_'+link.route : link.route})
      }
    }
  },
  computed: {
    styleObject: function() {
      return {
       '--primary-color': this.color,
       '--icon-active-color': this.color_rgba
      }
    },
    active_option: function () {
      return this.selected_item === this.name ? this.active = true : this.active = false;
    }
  },

}
</script>

<style>
  .navigation .v-list__group__header--active{
    background-color: var(--primary-color) !important;
  }

  .v-list__group--active .principal_option{
    color:  #FFFFFF !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/OptionNavigationDrawer.vue